import React from "react";

interface Props {
    heading: string;
    listItems: any[];
    selectedIds: any;
    setSelectedIds: any;
    type: number;
    handleSelectedPropertyOption: any;
    clearAll: any;
}

const SelectChips = (props: Props) => {

    if(props.selectedIds.length === 0){
        return <></>
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', background: 'white', padding: '0px 8px', marginRight: '6px', marginBottom: '10px' }}>
            {/* <p style={{ fontWeight: 600 , margin: '0px', paddingRight: '12px'}}>{props.heading}</p> */}
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center'}}>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', }}>
                    {props.selectedIds.length < 3 ? (
                        props.selectedIds.map((id:number, index: number) => {
                            const property = props.listItems.find(prop => prop.id === id);
                            return property ? (
                                <div key={property.id} style={{ display: 'flex', alignItems: 'center', borderRight: index === 0 && props.selectedIds.length>1 ? '1px solid #d2d2d2' : 'none'  }}>
                                    <span style={{ fontSize: '10px', paddingLeft: index === 1? '6px': '0px' }}>{property.name}</span>
                                    <button onClick={() => props.handleSelectedPropertyOption(property, props.type, props.selectedIds, props.setSelectedIds)} style={{ marginLeft: '5px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}>×</button>
                                </div>
                            ) : null;
                        })
                    ) : <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ fontSize: '12px' }}>{props.selectedIds.length} {props.heading} selected</span>
                            <button onClick={() => {
                               props.clearAll()
                            }} style={{ marginLeft: '5px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}>×</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default SelectChips;


// WEBPACK FOOTER //
// ./src/components/common/SelectChips.tsx